import { useEffect } from "react";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { initializeCookiebot } from "@/lib/cookiebot";

export function CookiebotInitializer() {
  const { data: siteSettings } = useSiteSettings();

  useEffect(() => {
    const cookiebotId = siteSettings?.cookiebot_id;
    if (!cookiebotId) return;
    // The editor preview runs inside a cross-origin frame. Cookiebot inspects
    // the top location and throws there; production pages are top-level.
    const hostname = window.location.hostname;
    if (
      window.self !== window.top ||
      hostname === "localhost" ||
      hostname.endsWith(".lovableproject.com")
    ) return;

    // Load once the browser is idle after hydration, instead of on a fixed
    // 3s timer that repainted the whole screen mid-load.
    let cancelled = false;
    const load = () => {
      if (!cancelled) initializeCookiebot(cookiebotId);
    };
    // Wait until the page has finished loading, then until the browser is
    // idle: the banner is still immediate for a visitor, but it no longer
    // repaints the screen while the content is still painting.
    let timer: number | undefined;
    const schedule = () => {
      const idle = (window as any).requestIdleCallback as
        | ((cb: () => void, opts?: { timeout: number }) => number)
        | undefined;
      if (idle) idle(load, { timeout: 1500 });
      else timer = window.setTimeout(load, 300);
    };

    if (document.readyState === "complete") schedule();
    else window.addEventListener("load", schedule, { once: true });

    return () => {
      cancelled = true;
      window.removeEventListener("load", schedule);
      if (timer !== undefined) window.clearTimeout(timer);
    };
  }, [siteSettings?.cookiebot_id]);

  return null;
}
